var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8711 24.7207V42.3996L29.4711 46.3996V27.1514C28.9224 27.9642 28.3673 28.7666 27.8122 29.5519C27.3465 30.2108 26.9139 30.8106 26.5254 31.3397C26.2918 31.658 26.1243 31.8825 26.0342 32.0018C25.7517 32.3754 25.1905 32.3754 24.908 32.0018C24.8178 31.8825 24.6504 31.658 24.4168 31.3397C24.0283 30.8106 23.5957 30.2108 23.13 29.5519C22.027 27.9915 20.9241 26.3638 19.8711 24.7207Z",
    fill: "#FFD2A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2664 22.1437V42.4L8.53784 46.4536C7.76402 46.776 7.12455 46.3884 7.06641 45.5805V17.9334V17.3189C7.06641 16.9009 7.40249 16.3933 7.81706 16.2206L14.0769 13.6123C14.6659 15.4193 15.6672 17.5589 17.0194 19.9886C17.41 20.6903 17.8265 21.4096 18.2664 22.1437Z",
    fill: "#FFD2A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9142 13.4297L40.795 11.8127C41.6041 11.4756 42.2664 11.9148 42.2664 12.7969V12.8664V40.4735V40.9474C42.2664 41.3654 41.9303 41.873 41.5158 42.0457L31.0664 46.3996V24.7207C31.2839 24.3814 31.4992 24.0414 31.7119 23.7012C32.5121 22.4218 33.2502 21.1798 33.9134 19.9882C35.3114 17.4763 36.3342 15.2745 36.9142 13.4297Z",
    fill: "#FFD2A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4954 26.9986C28.6487 25.367 29.802 23.6504 30.8792 21.9281C31.5727 20.8193 32.2124 19.7428 32.7871 18.7101C34.7561 15.1722 35.8664 12.3442 35.8664 10.4C35.8664 4.65624 31.2102 0 25.4664 0C19.7226 0 15.0664 4.65624 15.0664 10.4C15.0664 12.3442 16.1767 15.1722 18.1457 18.7101C18.7204 19.7428 19.3601 20.8193 20.0536 21.9281C21.1309 23.6504 22.2842 25.367 23.4374 26.9986C23.8411 27.5697 24.216 28.0895 24.5527 28.5481C24.7552 28.8239 24.9003 29.0185 24.9784 29.1219C25.2232 29.4456 25.7096 29.4456 25.9544 29.1219C26.0326 29.0185 26.1777 28.8239 26.3801 28.5481C26.7168 28.0895 27.0917 27.5697 27.4954 26.9986Z",
    fill: "#F48000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4648 14.4004C27.674 14.4004 29.4648 12.6095 29.4648 10.4004C29.4648 8.19125 27.674 6.40039 25.4648 6.40039C23.2557 6.40039 21.4648 8.19125 21.4648 10.4004C21.4648 12.6095 23.2557 14.4004 25.4648 14.4004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.324c848fcae3f6deb560f0bd262af817.svg";
export { ForwardRef as ReactComponent };